export const PAY = 'pay'
export const REGISTER_PAYMENT_METHOD = 'registerPaymentMethod'
